import { render, staticRenderFns } from "./AdminSelectedOrders.vue?vue&type=template&id=68ad00ec&scoped=true"
import script from "./AdminSelectedOrders.vue?vue&type=script&lang=js"
export * from "./AdminSelectedOrders.vue?vue&type=script&lang=js"
import style0 from "./AdminSelectedOrders.vue?vue&type=style&index=0&id=68ad00ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad00ec",
  null
  
)

export default component.exports